import { render, staticRenderFns } from "./PopUpBannerDetailTable.vue?vue&type=template&id=0d9b854e"
import script from "./PopUpBannerDetailTable.vue?vue&type=script&lang=js"
export * from "./PopUpBannerDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports